import axios from "axios";

export default {
  getRASReport(params) {
    return axios.get("/api/analytics/dashboard/report/ras", { params });
  },
  getIMARReport(params) {
    return axios.get("/api/analytics/dashboard/report/imar", { params });
  },
  getPMPKReport(params) {
    return axios.get("/api/analytics/dashboard/report/pmpk", { params });
  },
};
